import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#f5f3ef] text-[#1a2332]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/4615a989-9897-4237-a8ad-006c76b9905f.png"
              alt="Y・F・S"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-sm text-gray-600 leading-relaxed mb-6">
              中小企業の持続的成長を支える<br />
              集客・営業支援コンサルティング
            </p>

          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-gray-400 uppercase mb-5">
              <a href="/services">サービス</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: '集客コンサルティング', path: '/services#attraction' },
                { label: '営業支援コンサルティング', path: '/services#sales' },
                { label: '継続改善支援', path: '/services#improvement' },
                { label: '無料相談', path: '/contact' },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-sm text-gray-600 hover:text-[#1a2332] transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-gray-400 uppercase mb-5">
              <a href="/about">会社情報</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: '会社概要', path: '/about' },
                { label: '代表メッセージ', path: '/about#message' },
                { label: '会社概要詳細', path: '/company-overview' },
                { label: '支援事例', path: '/case-studies' },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-sm text-gray-600 hover:text-[#1a2332] transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-gray-400 uppercase mb-5">
              <a href="/contact">お問い合わせ</a>
            </h4>
            <ul className="space-y-3 text-sm text-gray-600">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-[#1a2332]" />
                <span>〒116-0003 東京都荒川区<br />南千住8－6－2－1113</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-[#1a2332]" />
                <span>090-222-8377</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-[#1a2332]" />
                <span>hayashi@y-f-s.jp</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-gray-200 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-400">© 2025 株式会社Y・F・S. All rights reserved.</p>

        </div>
      </div>
    </footer>
  );
}
